import { render } from "./sms.vue?vue&type=template&id=72b70cb2&scoped=true"
import script from "./sms.vue?vue&type=script&lang=js"
export * from "./sms.vue?vue&type=script&lang=js"

import "./sms.vue?vue&type=style&index=0&id=72b70cb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b70cb2"]])

export default __exports__